import { dataFetch } from '@lib/ggj-utils'

export default {
  // 身份证图片上传
  facePlusUpload(params) {
    return dataFetch('/wholesale/api/auth/ocrUpload/facePlus', params, {
      'method': 'post', headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 身份信息提交
  identityCommit(params) {
    return dataFetch('/wholesale/api/auth/identityCommit', params, {
      'method': 'post', headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 获取实名信息
  identity(params) {
    return dataFetch('/wholesale/api/auth/identity', params, {
      'method': 'get'
    })
  },

	// 获取协议信息
	getCommonAgreement(params) {
		return dataFetch(	"/user-customer-web/api/agreement/getCommonAgreement", { id: 300 }, {
			'method': 'get'
		})
	},
  // 获取人脸识别token fece++
  facePlus(params) {
    return dataFetch('/wholesale/api/auth/getFaceToken/facePlus', params, {
      'method': 'get'
    })
  },
  // 人脸识别完成
  finish(params) {
    return dataFetch('/wholesale/api/auth/face/finish', params, {
      'method': 'post', headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // face++人脸识别回调
  facepluscb(params) {
    return dataFetch('/identity-auth/api/user/auth/callback', params, {
      'method': 'post', headers: {
        'Content-Type': 'application/json'
      }
    })
	},
	// 同意签署协议
	acceptCommonAgreement (params) {
		return dataFetch('/user-customer-web/api/agreement/acceptCommonAgreement', params, {'method': 'post'})
	}
}
